"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadSVG = void 0;
const svg_parser_1 = require("svg-parser");
const svg_path_parser_1 = require("svg-path-parser");
const svgpath_1 = __importDefault(require("svgpath"));
const svgToPath_1 = __importDefault(require("./svgToPath"));
const extractTransformFromParseSvg = (parsed) => {
    let transform = '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function extractTransformation(parsed) {
        if (parsed.children && parsed.children.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            parsed.children.forEach((child) => {
                if (child.type === 'element' && child.tagName === 'path') {
                    if (child.properties && child.properties.transform) {
                        transform = child.properties.transform;
                    }
                }
                return extractTransformation(child);
            });
        }
        return transform;
    }
    return extractTransformation(parsed);
};
function extractedPathsFromParsedSvg(parsed) {
    const extractedPaths = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function extractPath(parsed) {
        if (parsed.children && parsed.children.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            parsed.children.forEach((child) => {
                if (child.type === 'element' && child.tagName === 'path') {
                    extractedPaths.push({
                        d: child.properties.d,
                        pathProperties: {
                            fill: child.properties.fill,
                            strokeColor: child.properties.stroke,
                            strokeWidth: child.properties['stroke-width'],
                            lineCap: child.properties['stroke-linecap'],
                            lineJoin: child.properties['stroke-linejoin'],
                            dashArray: child.properties['stroke-dasharray'],
                        },
                    });
                }
                extractPath(child);
            });
        }
        return extractedPaths;
    }
    return extractPath(parsed);
}
function loadSVG(svgString) {
    const stringWithPath = svgToPath_1.default(svgString); // Converting default svg shape elements into path
    const parsed = svg_parser_1.parse(stringWithPath);
    const svgTransformation = extractTransformFromParseSvg(parsed);
    const paths = extractedPathsFromParsedSvg(parsed);
    const parsedAbsolutePaths = paths.map((path) => {
        const transformed = svgpath_1.default(path.d);
        path.d = transformed.transform(svgTransformation).toString(); // return string path according the transformation
        const parsedPath = svg_path_parser_1.parseSVG(path.d);
        const absoluteParsedPath = svg_path_parser_1.makeAbsolute(parsedPath);
        return { d: absoluteParsedPath, pathProperties: path.pathProperties };
    });
    return parsedAbsolutePaths;
}
exports.loadSVG = loadSVG;
//# sourceMappingURL=utility.svg.js.map